import { type RefObject, useEffect, useState } from 'react'
import type { NativeMethods } from 'react-native'

/**
 * focus target element when trigger element is focused
 *
 *  @see {@link https://tamagui.dev/bento/forms/inputs}
 */
export function useForwardFocus<T extends NativeMethods | null>(target: RefObject<T>) {
  const [focused, setFocused] = useState(false)
  useEffect(() => {
    if (focused && target.current) {
      target.current.focus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused])

  /** apply this object on focus trigger element */
  return {
    onFocus: () => {
      setFocused(true)
    },
    onBlur: () => {
      setFocused(false)
    },
    focusable: true,
  }
}
